<template>
  <div class="body fixed mobile">
    <!-- Loading Spinner -->
    <spinner :spin="loading"/>
    <!-- Header -->
    
    <section class="header index">
            <a class="left">
                &nbsp;
            </a>
            <div class="uide-page-name">掃碼</div>
            <div class="right">
                <!-- <a class="icon iconButton" @click.prevent="barcodePopupOpen = true"> -->
                <a class="icon iconButton" @click.prevent="barcodePopupOpen = true">
                    
                    <!-- <font-awesome-icon icon="fa-solid fa-barcode" size="xl"></font-awesome-icon> -->
                    <img  src="@/assets/img/barcode.svg">
                </a>                          
            </div>
        </section>
    <!-- Main -->
    <section class="main scan">
      <!-- <a class="button fit rounded" @click.prevent="popCode()"
                ><span class="fS">手動輸入代碼</span></a
            > -->
      <QRCodeScanner
        ref="qrCodeScanner"
        @create-video="videoHandler"
        @video-ready="getReady($event)"
        @get-url="getUrl"
        @get-checkin="getCheckin"
        @get-checkin-random="getCheckin"
      />
      <a
        class="button fit rounded"
        @click.prevent="barcodePopupOpen = true"
        ><span class="fS">我的條碼</span></a
      >
    </section>
    <!-- Popup (Code) -->
    <BarcodePopup
      v-if="barcodePopupOpen"
      @closePopup="barcodePopupOpen = false"
    />
    <!-- Popup (Notice) -->
    <section id="popNotice" class="popup">
      <div class="popBody">
        <a class="close"><font-awesome-icon icon="fa-solid fa-times" /></a>
        <section class="popHeader">
          <!-- <span class="fL">Title</span> -->
        </section>
        <section class="popMain">
          <span class="fL">無法建立付款訂單</span>
        </section>
        <section class="popFooter">
          <a class="button submit rounded"><span class="fM">確認</span></a>
        </section>
      </div>
    </section>
    <AlertDialog
      :title="resultTitle"
      :content="resultMessage"
      v-if="showResultDialog"
      @close="onCloseResultDialog"
    />
    <section id="popLeave" class="popup">
      <div class="popBody">
        <a class="close" @click.prevent="closeLeaveModal"
          ><font-awesome-icon icon="fas fa-times"></font-awesome-icon
        ></a>
        <section class="popHeader">
          <!-- <span class="fL">Title</span> -->
        </section>
        <section class="popMain">
          <div class="fL text-center">提示</div>
          <div class="icon"></div>
          <span class="">您即將離開 App 前往外部連結，請問是否繼續？</span>
        </section>
        <section class="popFooter flex">
          <a
            class="button bg-transparent text-black border border-primary flex-1 submit rounded"
            @click.prevent="closeLeaveModal"
            >返回</a
          >
          <a class="button flex-1 submit rounded" @click.prevent="goOut()"
            ><span class="fM">確認</span></a
          >
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import QRCodeScanner from '@/components/QRCodeScanner.vue';
import BarcodePopup from '@/components/BarcodePopup.vue';
import Spinner from '@/components/Spinner.vue';
import AlertDialog from '@/components/Dialog/AlertDialog.vue'

import usePay from '@/utils/usePay';

export default {
  name: 'Scanner',
  components: {
    QRCodeScanner,
    BarcodePopup,
    Spinner,
    AlertDialog
  },
  data: function () {
    return {
      apiHost: process.env.VUE_APP_API_HOST,
      merchantId: process.env.VUE_APP_MERCHANT_ID,
      storeCode: '',
      video: null,
      isError: false,
      loading: false,
      barcodePopupOpen: false,
      resultTitle: '',
      resultMessage: '',
      showResultDialog: false,
      redirectUrl: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log(to, from);
    next((vm) => {
      let that = vm;
      if (that.user && that.user.userId) {
        //
      } else {
        next('/error');
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from);
    this.redirectUrl = ''
    this.stopStreamedVideo();
    next();
  },
  computed: {
    ...mapState(['user', 'userInfo']),
  },
  // mounted() {
  //   // 參數是掃到的原始字串：靜態 checkin:<uuid>，動態 checkin:<uuid>:<ts>:<checksum>
  //   this.getCheckin('checkin:3dfe67ed-f588-4e49-81b2-865d2513fc46');
  // },
  methods: {
    goOut() {
      window.open(this.redirectUrl, '_blank') || window.location.assign(this.redirectUrl)
      setTimeout(() => {
        this.closeLeaveModal();
      }, 1000);
    },
    linkClickHandler(url) {
      this.openLeaveModal();
      this.redirectUrl = url;
    },
    openLeaveModal() {
      const wrap = document.querySelector("#popLeave");
      wrap.style.display = "flex";
    },
    closeLeaveModal() {
      const wrap = document.querySelector("#popLeave");
      wrap.style.display = "none";
      this.$refs.qrCodeScanner.refresh()
    },
    onCloseResultDialog() {
      this.showResultDialog = false;
      this.resultTitle = '';
      this.resultMessage = '';
      this.$refs.qrCodeScanner.refresh();
      if (this.redirectUrl) {
        window.open(this.redirectUrl, '_blank') || window.location.assign(this.redirectUrl)
        this.redirectUrl = ''
      }
    },
    getUrl(url) {
      try {
        const { getRedirectUrl } = usePay();
        const redirectUrl = getRedirectUrl({
          userId: this.user.userId,
          userName: this.user.displayName,
          userPhone: this.user.phone,
          userEmail: this.user.user.email,
          nextUrl: url,
        });

        this.linkClickHandler(redirectUrl);

        // this.resultTitle = '提示'
        // this.resultMessage = '將為您開啟網頁'
        // this.showResultDialog = true
        // this.redirectUrl = redirectUrl
        // window.open(redirectUrl, '_blank') || window.location.assign(redirectUrl)
      } catch (error) {        
        this.$refs.qrCodeScanner.showScannerError("網址有誤");
      } finally {
        // setTimeout(() => {
        //   this.$refs.qrCodeScanner.refresh();
        // }, 1000);
      }
    },
    // 參數是「掃到的原始 QR 字串」，不是 uuid。
    // 標品的動態 QR 是 checkin:<uuid>:<timestamp>:<checksum> 四段，後端要靠後兩段
    // 驗 checksum 與過期；重組成 checkin:<uuid> 會讓動態 QR 一律驗不過。
    // 見 QRCodeScanner.vue 的 case 'checkin'。
    async getCheckin(qrcode) {
      const swHost = process.env.VUE_APP_SW_API_HOST;
      try {
        // Step 1: 驗證 QR Code，取得 campaignId + missionId
        const qrRes = await this.$http({
          url: `${swHost}/api/campaign/scanner/qr-code`,
          method: 'POST',
          data: { qrcode }
        });
        const campaignId = qrRes.data?.id;
        const missionId = qrRes.data?.missions?.[0]?.id;
        // 活動名稱只有 Step 1 這包有 —— Step 2 的回應是
        // { status, campaignComplete, reward }（CampaignCompleteService.php:236），
        // 沒有 campaignName，所以不能像舊站那樣從完成任務的回應裡拿。
        const campaignName = qrRes.data?.name || '活動';
        if (!campaignId || !missionId) {
          this.resultTitle = this.$t('check-in-failed.title')
          this.resultMessage = this.$t('check-in-failed.content')
          this.showResultDialog = true
          return;
        }

        // Step 2: 完成任務
        const res = await this.$http({
          url: `${swHost}/api/campaigns/${campaignId}/missions/${missionId}/complete`,
          method: 'POST',
          data: {
            uuid: this.user.userId,
            memberId: '',
            data: { qrcode }
          }
        });

        const reward = res.data?.reward;
        const rewardItem = Array.isArray(reward) ? reward[0] : reward;
        const rewarded = rewardItem?.status === 'success';
        const points = rewardItem?.points || 0;

        if (rewarded) {
          this.resultTitle = this.$t('check-in-success.title')
          //WARNING: 發到的不一定是點數。標品的無點數獎勵回的是
          //         { status:'success', points:0, rewardId }
          //         （CampaignCompleteService.php 的「無點數獎勵」分支），
          //         雲林拿它發小遊戲抽獎機會。照 check-in-success.content
          //         套版會變成「獲得雲林幣0枚」—— 明明抽獎次數有拿到。
          //         舊站有這條分支（point === 0 → 抽獎機會），改走標品時漏了。
          //         （PR #64 review 指出）
          //
          //         文案與站上其他頁一致：QADetail.vue:305、QA.vue:584、
          //         Campaign.vue:49 等都是同一句。
          this.resultMessage = points > 0
            ? this.$t('check-in-success.content', { name: campaignName, point: points })
            : '恭喜您獲得小遊戲抽獎機會 1 次!'
        } else if (res.data?.campaignComplete === 'completed') {
          this.resultTitle = this.$t('check-in-success.title')
          this.resultMessage = '任務完成，但點數已全數發放完畢。'
        } else {
          this.resultTitle = this.$t('check-in-failed.title')
          this.resultMessage = this.$t('check-in-failed.content')
        }
        this.showResultDialog = true
      } catch (err) {
        console.error('getCheckin err', err);
        const msg = err.response?.data?.message || err.response?.data?.result || this.$t('check-in-failed.content');
        this.resultTitle = this.$t('check-in-failed.title')
        this.resultMessage = msg
        this.showResultDialog = true
      }
    },
    videoHandler(e) {
      this.video = e;
    },
    stopStreamedVideo() {
      this.$refs.qrCodeScanner.stopStreamedVideo();
    },
    popNotice() {
      var popNotice = document.getElementById('popNotice');
      var close = popNotice.getElementsByClassName('close')[0];
      var submit = popNotice.getElementsByClassName('submit')[0];
      close.onclick = function () {
        popNotice.style.display = 'none';
      };
      submit.onclick = function () {
        popNotice.style.display = 'none';
      };
      window.onclick = function (event) {
        if (event.target == popNotice) {
          popNotice.style.display = 'none';
        }
      };
      popNotice.style.display = 'flex';
    },
    getAppointedStoreInfo(storeCode) {
      console.log(storeCode);
      var config = {
        method: 'get',
        url: `${this.apiHost}/stores/v1/merchants/${this.merchantId}/store-codes/${storeCode}`,
        headers: {},
      };

      return this.$http(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          throw error;
        });
    },
    getReady(isReady) {
      if (isReady) {
        this.loading = false;
      } else {
        //
        this.loading = false;
      }
    },
    createOrder(data) {
      let config = {
        url: `${this.apiHost}/payment/v1/merchants/${this.merchantId}/orders`,
        method: 'POST',
        data,
      };
      return this.$http(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          return response.data;
        })
        .catch(function (createOrderErr) {
          console.log('createOrder Err: ', createOrderErr);
          throw createOrderErr;
        });
    },
  },
  watch: {
    storeCode: function () {
      this.isError = false;
    },
  },
};
</script>

<style>
.vue-barcode-element {
  width: 100%;
}
</style>
